import JSXComponent from "../../dist/jsx-render/JSXComponent";
import dom from "../../dist/jsx-render/dom";
import { app } from "../Frame/App";
//import { isArray } from "jquery";
import { Picture } from "../Frame/Picture";

export type MeasureDocumentsDropdownProps = {
    measureId: number;

    /** The button or other element that triggers the dropdown menu */
    parentElement: HTMLElement;

    /** If set, the dropdown menu is aligned with the right side of the parent element. */
    alignRight?: boolean;
}

export class MeasureDocumentsDropdown extends JSXComponent {
    props: MeasureDocumentsDropdownProps;
    constructor(props: MeasureDocumentsDropdownProps) { super(props); }

    clientId: string = app.createRadomizedLetters(10);
    isOpen: boolean = false;

    element: HTMLElement;

    render() {
        this.props.parentElement.setAttribute("data-documents-id", this.clientId);
        this.props.parentElement.classList.add("dropdown");

        this.element = <div className="dropdown-menu documents-dropdown show" data-for-documents-id={this.props.parentElement.getAttribute("data-documents-id")}>
        </div>;

        $.ajax({
            url: app.resolveUrl("~/api/documents/getList/" + this.props.measureId),
            method: "GET",
            success: (response) => {


                if (response && Array.isArray(response) && response.length > 0) {
                    for (let item of response) {
                        var dropdownItem: HTMLElement = <div className="dropdown-item documents-item pointer" data-document-id={item.id} data-is-picture={item.isPicture}>
                            {item.name}
                        </div>
                        dropdownItem.addEventListener("click", this.openDocument);
                        this.element.appendChild(dropdownItem);
                    }
                } else {
                    this.element.appendChild(<div className="dropdown-item documents-item pointer">Keine Dokumente gefunden.</div>);
                }

                this.initDropdown();
            },
            error: (err) => {
                alert("Ein Fehler ist aufgetreten.");
                console.log(err);
            }
        });

        return this.element;
    }

    initDropdown = () => {
        var elementRect = this.element.getBoundingClientRect();
        if (this.props.alignRight) {
            this.element.style.transform = `translate3d(${20 - elementRect.width}px, 30px, 0px)`;
        } else {
            this.element.style.transform = `translate3d(-20px, 30px, 0px)`;
        }

        document.body.addEventListener("click", this.hideDropdown);
    }

    hideDropdown = () => {
        app.destroyDomElements(this.element);
        document.body.removeEventListener("click", this.hideDropdown);
    }

    openDocument = (event: MouseEvent) => {
        event.stopPropagation();
        event.cancelBubble = true;

        let documentId = (event.target as HTMLElement).getAttribute("data-document-id");
        let isPicture = (event.target as HTMLElement).getAttribute("data-is-picture");
        let name = (event.target as HTMLElement).innerText;
        if (documentId) {
            if (!isPicture || isPicture == "false") {
                window.location.href = app.resolveUrl("~/api/documents/get/" + documentId);
            } else {
                Picture.show(parseInt(documentId), name);
            }
        }

        this.hideDropdown();
    }
}